import type { ConfigurationParameters } from '@teemill/metrics';
import { Configuration, MetricsApi } from '@teemill/metrics';
import type { App } from 'vue';

export let metricsClient: MetricsApi;
export let monitorsClient: MetricsApi;
export let errorHandler: (e: any) => void;

export const metrics = {
  install(
    app: App,
    options: {
      metrics: {
        client: ConfigurationParameters;
      };
      monitors: {
        client: ConfigurationParameters;
      };
      errorHandler: (e: any) => void;
    },
  ) {
    metricsClient = new MetricsApi(
      new Configuration({
        ...options.metrics.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );
    monitorsClient = new MetricsApi(
      new Configuration({
        ...options.monitors.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );

    errorHandler = options.errorHandler || ((e) => console.error(e));
  },
};
